import { MitarbeiterSpeicheroptionenContent } from '@/domain/mitarbeiter/features/anlageassistent/components/MitarbeiterSpeicheroptionen/MitarbeiterSpeicheroptionenContent';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Separator,
} from '@e2n/ui/v2';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function MitarbeiterSpeicheroptionenDialog() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const [startEmail, _setStartEmail] = useState(
    form.getFieldValue('person.kontakt.email'),
  );

  return (
    <Dialog
      onOpenChange={(open) => {
        if (open === false) {
          form.setFieldValue('person.kontakt.email', startEmail);
        }
      }}>
      <form.Subscribe selector={(state) => [state.isSubmitting]}>
        {([isSubmitting]) => (
          <DialogTrigger asChild>
            <Button className="ml-auto" disabled={isSubmitting}>
              {isSubmitting ? (
                <FontAwesomeIcon icon={faSpinnerThird} spin className="mr-2" />
              ) : null}
              {t('domain.mitarbeiter.create.submitButton')}
            </Button>
          </DialogTrigger>
        )}
      </form.Subscribe>
      <DialogContent className="lg:w-170 p-0 gap-0">
        <div className="p-8">
          <DialogHeader className="space-y-3 pb-6">
            <DialogTitle>
              {t('domain.mitarbeiter.create.speicheroptionen.dialog.title')}
            </DialogTitle>
            <DialogDescription>
              {t(
                'domain.mitarbeiter.create.speicheroptionen.dialog.description',
              )}
            </DialogDescription>
          </DialogHeader>
          <MitarbeiterSpeicheroptionenContent />
        </div>
        <Separator />
        <DialogFooter className="p-4">
          <form.Subscribe selector={(state) => [state.isSubmitting]}>
            {([isSubmitting]) => (
              <Button disabled={isSubmitting} onClick={form.handleSubmit}>
                {isSubmitting ? (
                  <FontAwesomeIcon
                    icon={faSpinnerThird}
                    spin
                    className="mr-2"
                  />
                ) : null}
                {t('actions.fertig')}
              </Button>
            )}
          </form.Subscribe>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
